import React from "react";

import { Radio } from "@origin-digital/ods-core";

function createRadioOptions(options: {
  [key: string]: {
    text: string;
    value: string;
    selected: boolean;
    disabled: boolean;
  };
}): React.ReactElement[] {
  return Object.keys(options).map((key) => (
    <Radio
      key={key}
      id={options[key].text}
      label={options[key].text}
      value={options[key].value}
      checked={options[key].selected ?? undefined}
      disabled={options[key].disabled ?? false}
    />
  ));
}

export { createRadioOptions };
